import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

// Exclusão de profissional no quarkus.
export function useDeleteProfessional() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((professionalId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/dentista/${professionalId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
